import { render, staticRenderFns } from "./TowerTag.vue?vue&type=template&id=7ffa66ba&"
import script from "./TowerTag.vue?vue&type=script&lang=js&"
export * from "./TowerTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports